var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPazirexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 48,
    viewBox: "0 0 41 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2584_15212)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7695 26.6122L26.8769 25.6714V22.4134L22.7695 21.4737V18.7471L20.4996 17.7466V30.3423L22.7695 29.3406V26.6122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5062 35.0311L20.5 45.4073V47.9997L40.7573 36.3263V31.7832H38.4889L38.5062 35.0311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5004 0H20.5V2.59387L20.4996 2.59425L38.5062 12.9705L38.4803 21.7587H36.2551V16.2173L20.4996 7.13813V14.9209L22.75 16.2173V11.0288L32.1594 16.2466V31.7538L22.7504 36.9709V31.7831L20.5 33.0806V40.8638L36.2555 31.7831V26.1962L38.4762 26.1785H40.7581V11.673L20.5004 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4996 30.3434V17.7473L18.2294 18.749V21.7473L14.1224 22.4156V25.6748L18.2294 26.8866V29.3418L20.4996 30.3434Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0L0.241943 11.673V36.3263L20.5 47.9985V45.405L2.49305 35.031V12.9705L20.4996 2.5935V0H20.5Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4996 7.13818L18.2519 8.42817L18.2425 16.2158L20.4996 14.9209V7.13818Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2523 31.791L18.2529 31.7915V31.791H18.2523Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 40.8637V33.0806L18.2534 31.7917V39.5625L20.5 40.8637Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2584_15212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.5161,
    height: 48,
    fill: "white",
    transform: "translate(0.241943)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPazirexIcon);
export default __webpack_public_path__ + "static/media/Logo-Pazirex-Icon.bc308634e1fec20f03e53dc52c32b5da.svg";
export { ForwardRef as ReactComponent };